var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"select-item",style:(("height: " + _vm.selectItemHeight + "px"))},_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.withIcon)?_c('Icon',{staticClass:"icon",attrs:{"type":"tick","size":"16"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }